const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.'
]

function hideDevServerOverlay() {
  const overlay = document.getElementById('webpack-dev-server-client-overlay')
  const overlayDiv = document.getElementById(
    'webpack-dev-server-client-overlay-div'
  )

  if (overlay) {
    overlay.setAttribute('style', 'display: none')
  }
  if (overlayDiv) {
    overlayDiv.setAttribute('style', 'display: none')
  }
}

/**
 * Suppresses the benign "ResizeObserver loop ..." browser warning globally.
 *
 * Chart.js (responsive: true) and react-virtuoso resize elements inside
 * their own ResizeObserver callbacks, which makes the browser emit this
 * warning when widgets are resized. It only means some notifications were
 * deferred to the next frame — nothing is broken — but webpack-dev-server
 * treats it as a runtime error and shows its full-screen overlay.
 *
 * Call once at app bootstrap, before rendering.
 */
export function registerResizeObserverErrorSuppression() {
  window.addEventListener('error', (e) => {
    if (!RESIZE_OBSERVER_MESSAGES.includes(e.message)) {
      return
    }

    e.preventDefault()
    e.stopImmediatePropagation()

    // The dev-server overlay registers its error listener before the app
    // bundle runs, so it may already have rendered for this event — hide it
    // now and once more after it has had a chance to mount.
    hideDevServerOverlay()
    setTimeout(hideDevServerOverlay, 0)
  })
}
